<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import BillingList from './BillingList';
import ListDataEditor from '../content/ListDataEditor';
import EventEditor from '../events/Editor';

export default {
  name: "BillingPage",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/billing/billing/list'
    },
    {
      path: "list",
      component: BillingList,
      name: "Billing list"
    },
    {
      path: "event/:id",
      name: "Billing Event edit",
      components: {
        default: BillingList,
        bottomEditor: EventEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
    },

    {
      path: "content_edit/:id/:data_id",
      name: "Billing Content edit",
      components: {
        default: BillingList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
    }
  ]
}
</script>